import { useState, useEffect } from 'react'
import { BacnetExplorerList, BacnetObjectProperties } from '.'
import { Block } from "baseui/block";
import {  BacnetObjectState } from "../../services/mapping/bacnet";
import { Drawer, SIZE } from "baseui/drawer";

const BacnetExplorer = (props: { edgeDeviceId: string, deviceId: number, moduleId: string, resourceGroupId: string }) => {

    const [selected, setSelected] = useState<BacnetObjectState>();
    const [isOpen, setIsOpen] = useState(false);

    function onSelect(item: BacnetObjectState) {
        setSelected(item);
        setIsOpen(true);
    }


    return (
        <>
            <BacnetExplorerList resourceGroupId={props.resourceGroupId} edgeDeviceId={props.edgeDeviceId} deviceId={props.deviceId} onSelect={onSelect} moduleId={props.moduleId}></BacnetExplorerList>
            {isOpen && <Drawer
                isOpen={isOpen}
                autoFocus
                onClose={() => setIsOpen(false)}
                size={SIZE.auto}
            >
                <Block>
                    {selected &&
                        <BacnetObjectProperties edgeDeviceId={props.edgeDeviceId} deviceId={props.deviceId} instanceId={selected.instanceId} objectType={selected.objectType}></BacnetObjectProperties>
                    }
                    {!selected &&
                        <>no object selected</>}
                </Block>
            </Drawer>}
        </>
    )
}


export default BacnetExplorer;
